// @flow

import React from 'react';
import Pill from 'shared/components/common/Pill';
import { i18n } from 'shared/utils';

type Props = {
  status: string,
  width?: number,
};

const STATUS_COLORS = {
  DRAFT: 'grey',
  READY: 'blue',
  SHIPPED: 'orange',
  DELIVERED: 'green',
};

const STATUS_LABELS = {
  DRAFT: 'Draft',
  READY: 'Ready to Ship',
  SHIPPED: 'Shipped',
  DELIVERED: 'Delivered',
};

const ShipmentStatusPill = ({ status, width }: Props) => (
  <Pill color={STATUS_COLORS[status] || 'grey'} width={width}>
    {i18n.t(STATUS_LABELS[status] || status)}
  </Pill>
);

ShipmentStatusPill.defaultProps = {
  width: 110,
};

export default ShipmentStatusPill;
